const rmmLogo = require("../../../assets/images/rmmlogo2.png");
const safeLogo = require("../../../assets/images/safeprologo.png");
const safeFinLogo = require("../../../assets/images/safefin.png");
const rSecureLogo = require("../../../assets/images/rsecure.png");
const { httpConfig, Env } = require('../../../config');

const apiUrl = httpConfig.api;
const imagePath = `${apiUrl}/upload/image`;
const loginTitle = httpConfig.loginTitle;
const rmmApp = (Env === 'rmm') ? true : Env === 'emisafepro' ? true : Env === 'safefin' ? true : Env === 'rsecure' ? true : false; //mobile app control hide unhide, hide in EMI SAFEPRO build
const logoPath = ( Env === 'rmm' ) ? rmmLogo : (Env === 'emisafepro') ? safeLogo : (Env === 'safefin') ? safeFinLogo : (Env === 'rsecure') ? rSecureLogo :  rmmLogo;
export {apiUrl, imagePath, rmmApp, loginTitle, rmmLogo, safeLogo, safeFinLogo, logoPath, Env};
